export enum PeriodType {
  PERIOD = 'PERIOD',
  HOUR = 'HOUR',
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/enums/period-type.enum.ts